import { SCORING_PRIORITIES } from "../types/lead-priority";
import type { ScoringConfigRule } from "../types/scoring-config";

export const hasAnyScoringRules = (rules: ScoringConfigRule): boolean =>
    SCORING_PRIORITIES.some((priority) => (rules[priority]?.length ?? 0) > 0);
